import React from 'react';

import { Box, styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const Div_Wrapper = styled('div')(() => ({
  height: '75vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  '& .login-carousel-item-image': {
    maxHeight: '70%',
    objectFit: 'contain',
    maxWidth: 'fit-content',
    marginInline: 'auto',
  },
  '& .login-carousel-item-content': {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    justifyContent: 'center',
    maxWidth: 450,
    marginInline: 'auto',
  },
}));

const LoginCarouselItem = ({ image, title, description, image2x }) => (
  <Div_Wrapper>
    <Box
      component="img"
      className="login-carousel-item-image"
      src={image}
      alt=""
      srcSet={`${image} 1x, ${image2x} 2x`}
    />
    <Box className="login-carousel-item-content">
      <Typography align="center" variant="header" component="h2">
        {title}
      </Typography>
      <Typography align="center" component="p" variant="bodyLight">
        {description}
      </Typography>
    </Box>
  </Div_Wrapper>
);

LoginCarouselItem.propTypes = {
  image: PropTypes.string.isRequired,
  image2x: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default LoginCarouselItem;
